import { FC } from 'react'

import { View } from '@react-pdf/renderer'
import { PrintablePurchaseOrderTableFragment } from 'generated/resources/graphql'

import i18n from 'modules/core/lib/i18n'
import MoneyWithCurrency from 'modules/core/lib/money'

import Border from './Border'
import Cell from './Cell'
import Row from './Row'

interface Props extends PrintablePurchaseOrderTableFragment {
  locale: string
}

const Table: FC<Props> = ({ description, cost, locale }) => {
  const price = MoneyWithCurrency({
    amount: Number(cost.cents),
    currency: cost.currency,
    locale,
  })

  return (
    <View>
      <Row>
        <Cell flex={4} highlighted>
          {i18n.t('procurement.purchase_orders.pdf.description')}
        </Cell>
        <Cell textAlign="center" highlighted>
          {i18n.t('procurement.purchase_orders.pdf.quantity')}
        </Cell>
        <Cell textAlign="right" highlighted>
          {i18n.t('procurement.purchase_orders.pdf.unit_price')}
        </Cell>
        <Cell flex={2} textAlign="right" highlighted>
          {i18n.t('procurement.purchase_orders.pdf.total_excl_tax')}
        </Cell>
      </Row>
      <Border />
      <Row>
        <Cell flex={4}>{description}</Cell>
        <Cell textAlign="center">1</Cell>
        <Cell textAlign="right">{price}</Cell>
        <Cell flex={2} textAlign="right">
          {price}
        </Cell>
      </Row>
      <Border />
      <Row>
        <Cell flex={7} textAlign="right" highlighted>
          {i18n.t('procurement.purchase_orders.pdf.total_excl_tax')}
        </Cell>
        <Cell flex={1} textAlign="right" highlighted>
          {price}
        </Cell>
      </Row>
    </View>
  )
}

export default Table
